import React, { memo, useMemo, useState } from 'react'
import {
    TAverageWithInactivity,
    TAverageWithoutInactivity,
    TPoloWithLowSpeed,
    TPoloWithoutLowSpeed
} from '../../shared/types/exam.type'
import { Box, Card, CardContent, LinearProgress, Switch, Tooltip, Typography } from '@mui/material'
import { t } from 'i18next'
import { isEmpty, orderBy, sortBy, toNumber } from 'lodash'
import dayjs from 'dayjs'
import { Info } from '@mui/icons-material'
import { convertSpeedToNb, getSpeedForChart } from '../../shared/utils/conversion'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { TUser } from '../../shared/types/user.type'
import { useAuth } from '../../hooks/useAuth'

var duration = require('dayjs/plugin/duration')
dayjs.extend(duration)


type HrActivityProps = {
    params: {
        includeInactivity?: TPoloWithLowSpeed[],
        excludeInactivity?: TPoloWithoutLowSpeed[]
    },
    printable?: boolean
}

const colors = ["#caf0f8", "#90e0ef", "#0077B6", "#013e8b", "#03045e"]


function PoloActivityZone({ params, printable = false }: HrActivityProps) {


    const [include, setInclude] = useState(false)

    return (

        <div>


            <NotIncluded data={!include ? params.excludeInactivity : params.includeInactivity}></NotIncluded>
            {
                !printable && <Card elevation={3} sx={{
                    p: 1,
                    mt: 2,
                    borderRadius: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Typography pl={1} variant='subtitle2'>{t('speedZones:includeLowSpeed')}</Typography>
                    <Switch checked={include} onChange={e => setInclude(e.target.checked)}></Switch>
                </Card>
            }
        </div>
    )
}

const getTime = (seconds: number) => {
    return new Date(seconds * 1000)
        .toISOString()
        .slice(14, 19);
}

const getTitle = (index: number): { title: string } => ({ title: t('zone:withoutSpeed:' + index) })


function NotIncluded({ data }: { data?: TPoloWithoutLowSpeed[] | TPoloWithLowSpeed[] }) {

    const { getSpeedUnit } = useAuth()

    const getSpeed = (max?: number, min?: number, metric?: string) => {


        let _min = Math.round(toNumber(getSpeedForChart(min || 0, metric || "")))
        let _max = Math.round(toNumber(getSpeedForChart(max || 0, metric || "")))

        let unit = metric === 'imperial' ? t("units.mph") : t("units.kmh")

        if (max && min) {
            return `${_min} - ${_max} ${unit}`
        }
        if (max && !min) {
            return `< ${_max} ${unit}`
        } else {
            return `> ${_min} ${unit}`
        }
    }


    const orderedDataWithColor = useMemo(() => {
        let ordered = orderBy(data, 'index', 'desc')
        return ordered.map((item, index) => ({ ...item, color: colors[item.index] }))
    }, [data])


    return <>
        {!isEmpty(orderedDataWithColor) ? orderedDataWithColor?.map((item, i) => (
            <Box display={'flex'} flexDirection={'column'} gap={2} mb={1} key={item?.index}>
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Typography sx={{ textAlign: 'center', flex: 3, order: -3 }} variant='caption'
                        fontWeight={500}>{getTime(item?.time_seconds)}</Typography>
                    <Typography sx={{ flex: 4, order: -5 }} variant='caption'
                        fontWeight={500}>{getTitle(i).title}</Typography>

                    <Typography sx={{ flex: 3, order: -4 }} variant='caption'
                        fontWeight={500}>{getSpeed(item?.max_speed, item?.min_speed, getSpeedUnit()?.value || "")}</Typography>
                    <Typography sx={{ textAlign: 'right', flex: 2, order: 0 }} variant='caption'
                        fontWeight={500}>{item?.percentage + ' %'}</Typography>
                </Box>
                <LinearProgress sx={{
                    backgroundColor: 'transparent',
                    border: '0.5px solid gray',
                    overflow: 'hidden',
                    height: 12,
                    borderRadius: 1,
                    '& .MuiLinearProgress-bar': {
                        backgroundColor: item.color
                    }
                }} variant='determinate' value={item?.percentage}></LinearProgress>
            </Box>
        )) : <></>}
    </>
}

export default memo(PoloActivityZone)